export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idorigen: '',
        nombre: '',
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}